import script from "./editNetflyDomain.vue?vue&type=script&lang=ts&setup=true"
export * from "./editNetflyDomain.vue?vue&type=script&lang=ts&setup=true"

import "./editNetflyDomain.vue?vue&type=style&index=0&id=521eafcd&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521eafcd"]])

export default __exports__